// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const TwitterIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="22.719"
    height="18.463"
    viewBox="0 0 22.719 18.463"
    fill="currentColor"
  >
    <g transform="translate(0 0)">
      <path
        d="M47.822,36.214a9.3,9.3,0,0,1-2.677.733,4.674,4.674,0,0,0,2.05-2.578,9.331,9.331,0,0,1-2.96,1.131,4.665,4.665,0,0,0-7.943,4.252,13.231,13.231,0,0,1-9.607-4.871A4.666,4.666,0,0,0,28.126,41.1a4.628,4.628,0,0,1-2.111-.584c0,.02,0,.04,0,.059a4.664,4.664,0,0,0,3.739,4.57,4.679,4.679,0,0,1-2.1.081A4.666,4.666,0,0,0,32,48.467a9.409,9.409,0,0,1-6.9,1.93A13.255,13.255,0,0,0,45.509,39.229c0-.2,0-.4-.014-.6a9.452,9.452,0,0,0,2.326-2.412Z"
        transform="translate(-25.103 -34.028)"
      />
    </g>
  </Icon>
);

export default TwitterIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Social/Twitter.js